import { fromJS } from "immutable"

export const classState = fromJS({}) // stores all the loaded class

const initialState = fromJS({
  classList: [],
  cache: {},
  classHasFetched: false,
  pending: false,
  requesting: false,
})

export default function grade(state = initialState, action) {
  switch (action.type) {
    case "GRADE_REQ":
      return state.set("pending", true)

    case "GRADE_R_REQ":
      return state.set("requesting", true)

    case "GRADECL_GET_SUCC":
      return state
        .set("pending", false)
        .set("classHasFetched", true)
        .set("classList", fromJS(action.payload || []))

    case "GRADE_GETONE_SUCC":
      return state
        .set("pending", false)
        .set("requesting", false)
        .setIn(
          ["cache", action.meta.offeringGroupID],
          fromJS(action.payload || {})
        )

    case "GRADE_CACHE_SUCC":
      return state.setIn(
        ["cache", action.meta.offeringGroupID],
        action.meta.data
      )

    case "NOTIF_SUCC":
    case "NOTIF_FAIL":
      return state.set("pending", false).set("requesting", false)

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/containers/Grades/reducer.js